import _ from 'lodash';
import { mapGetters } from 'vuex';
import { STATUSES, EVENT_TYPES_HISTORY } from '~/utils/constants';
import timelineEvent from '~/mixins/timeline-event';

export default {
  mixins: [timelineEvent],
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    title() {
      const type = _.get(this.event, 'data.story_type.name', null);
      const data = _.get(this.event, 'data.info', {});

      if (type === 'STATUS_CHANGE') {
        this.event.data.from = this.$t('fn.complex.status', { code: this.getStatusCode(data.old_status_id) });
        this.event.data.to = this.$t('fn.complex.status', { code: this.getStatusCode(data.new_status_id) });
      } else if (type === 'START_DATE_CHANGE' || type === 'SYSTEM_START_DATE_CHANGE') {
        const key = _.has(data, 'new_start_date') ? 'new_start_date' : 'start_date';
        this.event.data.from = this.$t('fn.date', { timestamp: _.get(data, 'old_start_date', null) });
        this.event.data.to = this.$t('fn.date', { timestamp: _.get(data, key, null) });
      } else if (type === 'CAMPAIGN_CREATOR_CHANGED' || type === 'FB_PAGE_CHANGED') {
        this.event.data.from = _.get(this, 'event.info.from', data.from);
        this.event.data.to = _.get(this, 'event.info.to', data.to);
      } else if (type === 'LANDING_PAGE_CHANGED') {
        this.event.data.to = _.get(data, 'landing_page_link', null);
      }

      if (_.get(this.event, 'data.actor.first_name')) {
        this.event.data.actor.name = _.get(this.event, 'data.actor.first_name');
      }

      if (!_.get(this.event, 'data.actor')) {
        this.event.data.actor = {
          name: 'System Automation',
        };
      }

      let campaignFlag = '';
      if (_.get(this.event, 'data.campaignEvent')) {
        campaignFlag = this.$t('pos.timeline.campaign-event-flag');
      }

      const translationTitle = type === 'STATUS_CHANGE' && this.getStatusCode(data.new_status_id) === STATUSES.WRK
        ? 'CampaignHistoryCreativeMoved'
        : this.event.type;

      return `${campaignFlag} ${this.$t(
        `pos.timeline.timeline-events.title.${translationTitle}`,
        { event: this.event.data, userText: this.linkedUserConfig.userText },
      )}`;
    },
    component() {
      const data = _.get(this.event, 'data.info', {});

      if (this.event.data.story_type.name === EVENT_TYPES_HISTORY.NEW_TARGETING_REQUESTED ||
          this.event.data.story_type.name === EVENT_TYPES_HISTORY.NEW_TARGETING_APPLIED
      ) {
        const res = {
          name: 'CampaignTargetPopup',
          data: {
            target: {
              old: _.get(data, 'old_target', null),
              new: _.get(data, 'new_target', null),
            },
            status: _.get(this.campaign, 'target_change_status', null),
          },
        };

        return res;
      }
      return null;
    },
  },
  methods: {
    getStatusCode(id) {
      const steps = _.get(this.campaign, 'steps.steps', null);
      const item = Array.isArray(steps) && steps.find(step => step.id === id);
      if (item) {
        return item.code;
      }
      return null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/timeline/events/campaign-history/CampaignHistory.js